module.exports = __webpack_public_path__ + "img/UnityFrameworkRTSBehaviour.4551deb0.gif";